import Marquee from "react-fast-marquee";
import { ClientsWEWorkStyled } from "../../styles/StyledComponents/ClientsWEWorkStyled";
import CommonHeading from "../CommonHeading/CommonHeading";
import { marqueeSlidemock } from "../../ui/json/demo.mock";

const ClientsWEWork = () => {
  return (
    <ClientsWEWorkStyled className="cmn_gap_btm">
      <div className="container">
        <CommonHeading
          title="Clients we have worked with"
          isPrimary
          className="client_works_heading"
        />
        <div className="marquee_slide_wrap">
          <Marquee autoFill={true}>
            {marqueeSlidemock.map((data, index) => (
              <div className="figureWrap">
                <figure key={index}>
                  <img alt="" src={data} />
                </figure>
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </ClientsWEWorkStyled>
  );
};

export default ClientsWEWork;
